import { Store } from './../../store';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CmsService } from './../../services/cms.service';
import { Component, OnInit } from '@angular/core';
import {BreadcrumbsService} from '../../services/breadcrumbs.service';

@Component({
    selector: 'app-staff',
    templateUrl: './staff.component.html',
    styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {
    item;

    constructor(
        private route: ActivatedRoute,
        private cmsService: CmsService,
        private store: Store,
        private router: Router,
        private breadcrumbsService: BreadcrumbsService

    ) {
        this.router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd) {
                this.getStaff();
            }
        });

    }

    ngOnInit(): void {
        this.getStaff();
    }

    getStaff() {
        this.cmsService.getStaff(this.route.snapshot.params.slug).subscribe(data => {
            this.item = data;
            this.breadcrumbsService.changeBreadcrumb([
                { text: 'About us', route: ['/about-us'] },
                { text: this.item.name },
                { text: '' }
            ]);
        });
    }

}
